import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(d);
}

export function truncate(str, length = 100) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

const TURKISH_CHAR_MAP = {
  ı: 'i',
  ğ: 'g',
  ü: 'u',
  ş: 's',
  ö: 'o',
  ç: 'c',
  İ: 'i',
  Ğ: 'g',
  Ü: 'u',
  Ş: 's',
  Ö: 'o',
  Ç: 'c',
};

function normalizeTurkishChars(text) {
  return String(text).replace(/[ığüşöçİĞÜŞÖÇ]/g, (ch) => TURKISH_CHAR_MAP[ch] || ch);
}

/** SEO slug: lowercase, Turkish → ASCII, punctuation removed. */
export function slugifyProductName(text) {
  if (!text) return '';
  return normalizeTurkishChars(text)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
    .slice(0, 120);
}

export function generateSlug(text) {
  return slugifyProductName(text);
}
